var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3e54c30a68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 505 77.246094 L 519 77.246094 L 519 233 L 505 233 Z M 505 77.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "feb88d8ff6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 351.445312 364 L 673.195312 364 L 673.195312 419 L 351.445312 419 Z M 351.445312 364 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6314af0e8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 421 364 L 673.195312 364 L 673.195312 409 L 421 409 Z M 421 364 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "753f33b68a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 351.445312 310 L 673.195312 310 L 673.195312 365 L 351.445312 365 Z M 351.445312 310 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcab260f2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 421 310 L 673.195312 310 L 673.195312 355 L 421 355 Z M 421 310 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f04b888527"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 354 418 L 670 418 L 670 498.746094 L 354 498.746094 Z M 354 418 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bcc19670d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 354 418 L 461 418 L 461 498.746094 L 354 498.746094 Z M 354 418 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e54c30a68)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60557d",
    d: "M 512.320312 232.230469 C 508.804688 232.230469 505.957031 229.386719 505.957031 225.878906 L 505.957031 83.601562 C 505.957031 80.089844 508.804688 77.246094 512.320312 77.246094 C 515.832031 77.246094 518.683594 80.089844 518.683594 83.601562 L 518.683594 225.878906 C 518.683594 229.386719 515.832031 232.230469 512.320312 232.230469 Z M 512.320312 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#feb88d8ff6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b361f",
    d: "M 673.167969 391.5625 C 673.167969 397.601562 671.199219 403.167969 667.867188 407.675781 C 662.914062 414.378906 654.957031 418.726562 645.984375 418.726562 L 378.660156 418.726562 C 371.152344 418.726562 364.351562 415.683594 359.429688 410.769531 C 354.511719 405.855469 351.464844 399.070312 351.464844 391.5625 C 351.464844 376.566406 363.636719 364.40625 378.65625 364.40625 L 645.984375 364.40625 C 653.492188 364.40625 660.285156 367.449219 665.203125 372.363281 C 670.125 377.277344 673.167969 384.0625 673.167969 391.5625 Z M 673.167969 391.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6314af0e8e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b35222",
    d: "M 673.167969 391.5625 C 673.167969 397.601562 671.199219 403.167969 667.867188 407.675781 C 665.757812 408.347656 663.515625 408.703125 661.191406 408.703125 L 443.1875 408.703125 C 437.070312 408.703125 431.523438 406.21875 427.511719 402.21875 C 423.5 398.207031 421.015625 392.671875 421.015625 386.554688 C 421.015625 374.328125 430.949219 364.410156 443.1875 364.410156 L 645.984375 364.410156 C 653.492188 364.410156 660.285156 367.449219 665.203125 372.363281 C 670.125 377.277344 673.167969 384.0625 673.167969 391.5625 Z M 673.167969 391.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#753f33b68a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b361f",
    d: "M 645.984375 364.410156 C 661 364.410156 673.171875 352.253906 673.171875 337.253906 C 673.171875 322.257812 661 310.097656 645.984375 310.097656 L 378.65625 310.097656 C 363.640625 310.097656 351.46875 322.257812 351.46875 337.253906 C 351.46875 352.253906 363.640625 364.410156 378.65625 364.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcab260f2c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b35222",
    d: "M 673.167969 337.25 C 673.167969 343.292969 671.199219 348.859375 667.867188 353.367188 C 665.757812 354.035156 663.515625 354.390625 661.191406 354.390625 L 443.1875 354.390625 C 437.070312 354.390625 431.523438 351.910156 427.511719 347.910156 C 423.5 343.894531 421.015625 338.363281 421.015625 332.242188 C 421.015625 320.019531 430.949219 310.097656 443.1875 310.097656 L 645.984375 310.097656 C 653.492188 310.097656 660.285156 313.140625 665.203125 318.054688 C 670.125 322.96875 673.167969 329.753906 673.167969 337.25 Z M 673.167969 337.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f04b888527)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f28900",
    d: "M 645.855469 418.722656 L 378.785156 418.722656 C 365.578125 418.722656 354.867188 429.417969 354.867188 442.613281 L 354.867188 449.808594 C 354.867188 476.835938 376.800781 498.746094 403.859375 498.746094 L 620.78125 498.746094 C 647.839844 498.746094 669.773438 476.835938 669.773438 449.808594 L 669.773438 442.613281 C 669.773438 429.417969 659.0625 418.722656 645.855469 418.722656 Z M 645.855469 418.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bcc19670d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d87805",
    d: "M 411.726562 449.8125 L 411.726562 442.613281 C 411.726562 429.417969 422.4375 418.722656 435.644531 418.722656 L 378.785156 418.722656 C 365.578125 418.722656 354.867188 429.417969 354.867188 442.613281 L 354.867188 449.8125 C 354.867188 476.835938 376.800781 498.746094 403.859375 498.746094 L 460.71875 498.746094 C 433.660156 498.746094 411.726562 476.835938 411.726562 449.8125 Z M 411.726562 449.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9b361f",
    d: "M 478.023438 310.097656 L 554.371094 386.359375 L 630.71875 310.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fddc65",
    d: "M 645.984375 310.101562 L 635.144531 320.929688 L 569.640625 386.359375 L 504.128906 320.929688 L 493.289062 310.101562 Z M 645.984375 310.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f28900",
    d: "M 378.785156 310.097656 L 645.855469 310.097656 C 659.0625 310.097656 669.773438 299.402344 669.773438 286.207031 L 669.773438 279.117188 C 669.773438 227.957031 628.253906 186.484375 577.035156 186.484375 L 447.605469 186.484375 C 396.386719 186.484375 354.867188 227.957031 354.867188 279.117188 L 354.867188 286.207031 C 354.867188 299.402344 365.574219 310.097656 378.785156 310.097656 Z M 378.785156 310.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d87805",
    d: "M 412.117188 286.207031 L 412.117188 279.117188 C 412.117188 227.957031 453.636719 186.480469 504.851562 186.480469 L 447.605469 186.480469 C 396.386719 186.480469 354.867188 227.957031 354.867188 279.117188 L 354.867188 286.207031 C 354.867188 299.398438 365.574219 310.097656 378.785156 310.097656 L 436.035156 310.097656 C 422.824219 310.097656 412.117188 299.402344 412.117188 286.207031 Z M 412.117188 286.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef2e61",
    d: "M 587.367188 88.921875 L 505.957031 88.921875 L 505.957031 146.523438 L 587.367188 146.523438 L 569.28125 117.722656 Z M 587.367188 88.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed799",
    d: "M 427.71875 232.230469 C 424.207031 232.230469 421.355469 229.386719 421.355469 225.878906 L 421.355469 208.085938 C 421.355469 204.578125 424.207031 201.730469 427.71875 201.730469 C 431.234375 201.730469 434.082031 204.578125 434.082031 208.085938 L 434.082031 225.878906 C 434.082031 229.386719 431.234375 232.230469 427.71875 232.230469 Z M 427.71875 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed799",
    d: "M 512.320312 232.230469 C 508.804688 232.230469 505.957031 229.386719 505.957031 225.878906 L 505.957031 208.085938 C 505.957031 204.578125 508.804688 201.730469 512.320312 201.730469 C 515.832031 201.730469 518.683594 204.578125 518.683594 208.085938 L 518.683594 225.878906 C 518.683594 229.386719 515.832031 232.230469 512.320312 232.230469 Z M 512.320312 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed799",
    d: "M 596.921875 232.230469 C 593.40625 232.230469 590.558594 229.386719 590.558594 225.878906 L 590.558594 208.085938 C 590.558594 204.578125 593.40625 201.730469 596.921875 201.730469 C 600.433594 201.730469 603.28125 204.578125 603.28125 208.085938 L 603.28125 225.878906 C 603.28125 229.386719 600.433594 232.230469 596.921875 232.230469 Z M 596.921875 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed799",
    d: "M 470.019531 232.230469 C 466.507812 232.230469 463.65625 229.386719 463.65625 225.878906 L 463.65625 208.085938 C 463.65625 204.578125 466.507812 201.730469 470.019531 201.730469 C 473.535156 201.730469 476.382812 204.578125 476.382812 208.085938 L 476.382812 225.878906 C 476.382812 229.386719 473.53125 232.230469 470.019531 232.230469 Z M 470.019531 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed799",
    d: "M 554.621094 232.230469 C 551.109375 232.230469 548.257812 229.386719 548.257812 225.878906 L 548.257812 208.085938 C 548.257812 204.578125 551.109375 201.730469 554.621094 201.730469 C 558.136719 201.730469 560.984375 204.578125 560.984375 208.085938 L 560.984375 225.878906 C 560.980469 229.386719 558.132812 232.230469 554.621094 232.230469 Z M 554.621094 232.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#eba31e",
    d: "M 645.984375 310.101562 L 635.144531 320.929688 L 504.128906 320.929688 L 493.289062 310.101562 Z M 645.984375 310.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.a002ba454e5f75f8618ce0abc6166261.svg";
export { ForwardRef as ReactComponent };